/*
 *		Copyright (c) 2011-2014 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

angular.module('access.FileSystem')
    .filter('fileSize', ['FileSize', '$filter', function(FileSize, $filter) {
        var
            PRECISION = 2,
            UNITS = FileSize.units;

        return function(inputValue, inputUnit, precision) {
            var
                bytes = FileSize.bytes(inputValue, inputUnit);

            if(angular.isUndefined(precision)) {
                precision = PRECISION;
            }

            if(bytes === 0) {
               return '0 ' + $filter('translate')( UNITS[0] );
            }
            else if(!bytes && bytes !== 0) {
                return;
            } else {
                var
                    number = Math.floor(Math.log(bytes) / Math.log(1024));
                return (bytes / Math.pow(1024, Math.floor(number))).toFixed(precision) +  ' ' + $filter('translate')( UNITS[number] );
            }
        }
}]);
